// Import model
import { UpdatePickListItemRequest } from '../models/UpdatePickListItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePickListItemRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdatePickListItemRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdatePickListItemRequest instance
   */
  static deserialize(json: string): UpdatePickListItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePickListItemRequest instance
   */
  static fromObject(obj: any): UpdatePickListItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePickListItemRequest');
    }


    const instance: UpdatePickListItemRequest = {
      createdBy: obj['createdBy'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      pickListId: obj['pickListId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePickListItemRequest instances
   */
  static deserializeArray(json: string): UpdatePickListItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePickListItemRequest instance to a JSON string
   */
  static serialize(instance: UpdatePickListItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePickListItemRequest instance to a plain object
   */
  static toObject(instance: UpdatePickListItemRequest): any {
    return {
      'createdBy': instance.createdBy,
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'description': instance.description,
      'pickListId': instance.pickListId,
    };
  }

  /**
   * Serializes an array of UpdatePickListItemRequest instances to a JSON string
   */
  static serializeArray(instances: UpdatePickListItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
